import { HttpResponse, graphql } from 'msw';

import MockBuilder from '~/apis/mocks/MockBuilder';
import {
  type GetEligibleFinancingOut,
  type Score,
  type SearchKitBySkuAndRegionOut,
  type SearchKitOut,
  type User,
} from '~/types/ecommerce/generated.codegen';

export default [
  graphql.query('UserInfo', () => {
    return HttpResponse.json(new MockBuilder().graphql().get<User>('user'));
  }),
  graphql.query('getScoreSolfacilPlus', () => {
    return HttpResponse.json(new MockBuilder().graphql().get<Score>('score'));
  }),
  graphql.query('SearchKit', () => {
    return HttpResponse.json(
      new MockBuilder().graphql().get<SearchKitOut>('kits'),
    );
  }),
  graphql.query('getCartByPartnerId', () => {
    return HttpResponse.json(new MockBuilder().graphql().get<User>('cart'));
  }),
  graphql.query('getDeliveryTime', () => {
    return HttpResponse.json(
      new MockBuilder().graphql().get<User>('deliveryTime'),
    );
  }),
  graphql.query('searchKitBySkuAndRegion', () => {
    return HttpResponse.json(
      new MockBuilder().graphql().get<SearchKitBySkuAndRegionOut>('kit'),
    );
  }),
  graphql.query('getEligibleFinancing', () => {
    return HttpResponse.json(
      new MockBuilder().graphql().get<GetEligibleFinancingOut>('financing'),
    );
  }),
];
